import { BrowserRouter as Router, Routes, Route } from "react-router-dom"; // Import routing components
//import logo from "./assets/logo_white.svg";
import ec_logo from "./assets/logo-ec--en.svg";
import { Box, Stack, Container, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import "./App.css";
import { messages } from "./config/messages";
import ParticipantForm from "./formViews/ParticipantForm";
import StartPage from "./StartPage";
import ParticipantConnectorForm from "./formViews/ParticipantConnectorForm";
import ParticipantListOfConnectors from "./formViews/ParticipantListOfConnectors";
import DocumentUploadSection from "./formViews/DocumentUploadSection";
import UserRegistryHome from "./UserRegistryHome";
import ParticipantList from "./participants/ParticipantListWithsSorting";
import SubmissionSuccess from "./formViews/SubmissionSuccess";
import PrivateRoute from "./PrivateRoute";
import { USER_ACTIONS } from "./config/auth";
import { useKeycloak } from "@react-keycloak/web";
import { useEffect, useState } from "react";
import setupAxiosInterceptors from "./config/setupAxios";
import { keycloak, setAuthKeycloak } from "./config/auth";
import MainNavigation from "./MainNavigation";
import MessagesNotification from "./messages-notifications/MessagesNotification";
import { BASENAME } from "./config/settings";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./theme";

function App() {
  const { keycloak } = useKeycloak();
  const isAuth = keycloak.authenticated;

  useEffect(() => {
    setupAxiosInterceptors(keycloak);
    setAuthKeycloak(keycloak);
  });

  return (
    <>
      <ThemeProvider theme={theme}>
        <Router basename={`${BASENAME}/`}>
          <MainNavigation />
          <Box component="header" className="header-elc-shadow">
            {/* Gray Bar with Title */}
            <Box
              sx={{ backgroundColor: "#f0f3fa", px: 2, py: 1 }}
              className="header-elc-gradient"
            >
              <Container maxWidth="xl">
                <Typography
                  variant="h2"
                  sx={{ color: "#00002e", pt: "0.5rem", pb: "0.5rem" }}
                >
                  {messages.startPageTitle}
                </Typography>
              </Container>
            </Box>
          </Box>

          <Stack sx={{ mb: 1 }}>
            <Box>
              <Routes>
                <Route path="/" element={<StartPage />} />
                <Route path="/participant-form" element={<ParticipantForm />} />
                <Route
                  path="/participant-form/:id"
                  element={
                    <PrivateRoute action={USER_ACTIONS.UPDATE_OWN_FORM}>
                      {<ParticipantForm />}
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/participant-documents/:id"
                  element={
                    <PrivateRoute
                      action={
                        USER_ACTIONS.UPDATE_OWN_FORM ||
                        USER_ACTIONS.ADMINISTER_PARTICIPANT_REGISTRY ||
                        USER_ACTIONS.VIEW_PARTICIPANT_REGISTRY
                      }
                    >
                      {<DocumentUploadSection />}
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/connector-form"
                  element={
                    <PrivateRoute action={USER_ACTIONS.UPDATE_OWN_CONNECTOR}>
                      <ParticipantConnectorForm />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/connector-form/:id"
                  element={
                    <PrivateRoute action={USER_ACTIONS.UPDATE_OWN_FORM || USER_ACTIONS.UPDATE_OWN_CONNECTOR}>
                      <ParticipantConnectorForm />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/management"
                  element={
                    <PrivateRoute
                      action={
                        USER_ACTIONS.UPDATE_OWN_FORM ||
                        USER_ACTIONS.ADMINISTER_PARTICIPANT_REGISTRY ||
                        USER_ACTIONS.VIEW_PARTICIPANT_REGISTRY ||
                        USER_ACTIONS.UPDATE_OWN_CONNECTOR
                      }
                    >
                      <UserRegistryHome />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/connector-list"
                  element={
                    <PrivateRoute
                      action={
                        USER_ACTIONS.UPDATE_OWN_FORM ||
                        USER_ACTIONS.ADMINISTER_PARTICIPANT_REGISTRY ||
                        USER_ACTIONS.UPDATE_OWN_CONNECTOR ||
                        USER_ACTIONS.VIEW_PARTICIPANT_REGISTRY
                      }
                    >
                      <ParticipantListOfConnectors />
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/submission-success"
                  element={<SubmissionSuccess />}
                />
                <Route
                  path="/participant-list"
                  element={
                    <PrivateRoute
                      action={
                        USER_ACTIONS.ADMINISTER_PARTICIPANT_REGISTRY ||
                        USER_ACTIONS.VIEW_PARTICIPANT_REGISTRY
                      }
                    >
                      {<ParticipantList />}
                    </PrivateRoute>
                  }
                />
                <Route
                  path="/messages"
                  element={
                    <PrivateRoute
                      action={
                        USER_ACTIONS.ADMINISTER_PARTICIPANT_REGISTRY
                      }
                    >
                      {<MessagesNotification />}
                    </PrivateRoute>
                  }
                />
              </Routes>
            </Box>
          </Stack>

          <footer className="site-footer">
            <Container maxWidth="lg">
              <Grid container justifyContent={"space-between"} spacing={2}>
                <Grid size={6}>
                  <a href="https://commission.europa.eu/index_en">
                    <img
                      className="ecl-site-footer__logo-image"
                      src={ec_logo}
                      alt="European Commission logo"
                    />
                  </a>
                </Grid>
                <Grid size={6}>
                  <Stack spacing={2}>
                    <div className="site-footer__title">
                      <Typography variant="h4">
                        {messages.footerAboutHeading}
                      </Typography>
                    </div>
                    <Typography variant="h5">
                      <a
                        href="https://language-data-space.ec.europa.eu/index_en"
                        rel="external"
                        target="_blank"
                      >
                        {messages.footerAboutLink}
                      </a>
                    </Typography>
                  </Stack>
                </Grid>
              </Grid>
            </Container>
          </footer>
        </Router>
      </ThemeProvider>
    </>
  );
}

export default App;
